import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MoreBtn from "../Components/MoreBtn";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmApply from "../Modals/AlarmApply";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { nation_to_cCode } from "../Utils/numberUtils";
import { showToast } from "../Utils/variables";

const QnAManageContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [total_QnA, setTotal_QnA] = useState(0);
  const [QnA_list, setQnA_list] = useState([]);

  const [page, setPage] = useState(1);
  const offset = 10;

  const [searchTitle, setSearchTitle] = useState("");
  const [status, setStatus] = useState(null);
  const [nation, setNation] = useState(null);

  const [clickDelete, setClickDelete] = useState(false);
  const [qnaId, setQnAId] = useState(null);
  const [clickInput, setClickInput] = useState(false);
  const lastQnARequestKey = useRef(null);

  const getQnAList = async () => {
    try {
      const body = {
        page,
        offset,
        searchTitle,
        status: status === "답변대기" ? 0 : status === "답변완료" ? 1 : null,
        cCode: nation_to_cCode(nation),
      };
      const res = await postJson("/dashboard/qna/getList", body, navigate);

      if (res.code === 200) {
        setTotal_QnA(res.data.count);
        setQnA_list(res.data.rows);
      }
    } catch (error) {
      console.log("문의 리스트 가져오기 중 에러");
      throw error;
    }
  };

  const handleDeleteQnA = async (qnaId) => {
    try {
      const body = { qnaId };
      const res = await postJson("/dashboard/qna/delete", body, navigate);

      if (res.code === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log("문의 삭제 중 에러");
      throw error;
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ status, nation, page });

    if (lastQnARequestKey.current === requestKey) {
      return;
    }

    lastQnARequestKey.current = requestKey;
    getQnAList();
  }, [status, nation, page]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("문의 답변이 등록되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div>
      {clickDelete && (
        <AlarmApply
          title="항목을 삭제하시겠습니까?"
          subtitle="삭제하면 앱과 대시보드 내에서 해당 데이터가 영구적으로 사라집니다."
          handleApply={() => handleDeleteQnA(qnaId)}
          handleClickX={() => setClickDelete(false)}
        />
      )}
      {/* 문의 관리 박스 */}
      <QnABox>
        <div className="title-in-box">문의 관리</div>
        {/* 검색창 | 드롭다운 옵션 2개 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="닉네임, 문의내용"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getQnAList();
                }
              }}
            />
            <IconSearch style={{ cursor: "pointer" }} onClick={getQnAList} />
          </div>

          {/* 드롭다운 옵션 */}
          <div style={{ display: "flex", marginLeft: "auto" }}>
            <DropdownOption
              title="답변 여부"
              dropdown_list={["답변완료", "답변대기"]}
              optionChange={(value) => setStatus(value)}
            />
            <DropdownOption
              title="전체 국가"
              dropdown_list={["대한민국", "미국", "대만", "일본", "중국"]}
              optionChange={(value) => setNation(value)}
            />
          </div>
        </div>

        {/* 전체 문의 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_QnA?.toLocaleString()}건
        </div>

        {/* 문의 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns: "100px 230px 330px 230px 140px 470px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">닉네임</p>
            <p className="leftalign">문의 내용</p>
            <p className="leftalign">등록일</p>
            <p className="leftalign">국가</p>
            <p className="leftalign">답변 여부</p>
          </div>

          {/* 데이터 */}
          {QnA_list.slice(0, 10).map((data) => (
            <QnAData
              key={data.rownum}
              rownum={data.rownum}
              nickName={data.nickName}
              content={data.content}
              regTime={data.regTime}
              cCode={data.cCode}
              status={data.status}
              qnaId={data.qnaId}
              setClickDelete={setClickDelete}
              setQnAId={setQnAId}
            />
          ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_QnA === 0 ? 1 : Math.ceil(total_QnA / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </QnABox>
    </div>
  );
};

const QnAData = ({
  rownum,
  nickName,
  content,
  regTime,
  cCode,
  status,
  qnaId,
  setClickDelete,
  setQnAId,
}) => {
  const nation =
    cCode === "kr"
      ? "대한민국"
      : cCode === "cn"
      ? "중국"
      : cCode === "us"
      ? "미국"
      : cCode === "jp"
      ? "일본"
      : cCode === "tw"
      ? "대만"
      : null;
  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns: "100px 230px 330px 230px 140px 418px 52px",
      }}
    >
      <p className="center">{rownum?.toLocaleString()}</p>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{nickName}</p>
      </div>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{content}</p>
      </div>
      <p className="leftalign">{regTime}</p>
      <p className="leftalign">{nation}</p>
      <p
        className="leftalign"
        style={status === 0 ? { color: "#F25C5C" } : { color: "#1167ed" }}
      >
        {status === 0 ? "답변대기" : "답변완료"}
      </p>

      <div className="center">
        <MoreBtn
          option1="답변 등록"
          option1Addr={`/qna/apply/${qnaId}`}
          option2="삭제"
          optionClickDelete={() => {
            setClickDelete(true);
            setQnAId(qnaId);
          }}
        />
      </div>
    </div>
  );
};

const QnABox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px;
`;

const QnAManage = () => {
  return <Layout page={<QnAManageContent />} />;
};
export default QnAManage;
